/**
 * Model reprezentujący rezerwację zaimportowaną z zewnętrznego systemu KlinikiXP,
 * która wymaga opłacenia przez pacjenta za pomocą dedykowanego linku (Pay-by-Link).
 * Łączy dane z kalendarza zewnętrznego z mechanizmami komunikacji (SMS/E-mail) i statusem płatności.
 */
export class KlinikaxpPaymentRequiredReservation {


  /** Globalnie unikalny identyfikator rekordu płatności. */
  public uuid: string;
  public created: Date;
  public modified: Date;

  /** Identyfikator administratora/pracownika, który wyzwolił lub zmodyfikował ten proces. */
  public authorUUID: string;
  public modifiedBy: string;

  /** Vetcode lecznicy.
   * Gwarantuje separację danych w środowisku wielodostępnym (Multi-tenant).
   */
  public vetcodeId: number;

  /** Identyfikator wygenerowanej na tej podstawie wizyty w Vetineo. */
  public vetineoVisitUUID: string;

  /** Identyfikator konkretnego "Terminu" bezpośrednio w bazie zewnętrznego systemu KlinikiXP.
   */
  public terminId: number;

  /** Zewnętrzny identyfikator kliniki/oddziału z systemu KlinikiXP. */
  public clinicXpId: string;

  /** Zewnętrzny identyfikator lekarza prowadzącego. */
  public doctorId: number;

  /** Zewnętrzny identyfikator typu wizyty (usługi). */
  public visitTypeId: number;

  public color: number;

  /** Data utworzenia rekordu. */
  public addTime: Date;

  /** Data ostatniej modyfikacji rekordu. */
  public timeChg: Date;

  /** Planowana data i czas rozpoczęcia wizyty. */
  public startDate: string;

  /** Planowana data i czas zakończenia wizyty. */
  public endDate: Date;

  /** Imię i nazwisko lekarza weterynarii. */
  public vetDoctorName: string;

  /** Powiązany typ wizyty lekarza (obiekt z systemu Vetineo). */
  public vetDoctorVetVisitTypeUUID: string;

  /** Temat wizyty (np. "Konsultacja dermatologiczna"). */
  public subject: string;

  /** Rozszerzony opis / notatka do wizyty. */
  public opis: string;

  /** Flaga określająca, czy jest to zabieg medyczny. */
  public isMedicalProcedure: boolean;

  /** Surowy ciąg znaków reprezentujący klienta. */
  public customer: string;

  public userFirstName: string;
  public userLastName: string;
  public userPhoneNumber: string;
  public email: string;

  /** Imię zwierzęcia (pacjenta). */
  public petName: string;


  /** Wymagana kwota do zapłaty.
   */
  public amount: number;

  /** Ostateczny termin opłacenia linku (Due Date/Time).
   */
  public finalPaymentDate: string;

  /** Data i czas faktycznego opłacenia należności.
   * Jeśli pole jest puste (null), oznacza to, że transakcja wciąż oczekuje na realizację.
   */
  public wasPaid: Date;

  /** Flaga decydująca, czy system ma wysłać link do płatności mailem. */
  public sendEmail: boolean;
  /** Flaga decydująca, czy system ma wysłać link do płatności bramką SMS. */
  public sendSMS: boolean;

  /** Rzeczywista data wysłania wiadomości E-mail. */
  public sendEmailDate: Date;
  /** Rzeczywista data wysłania wiadomości SMS. */
  public sendSMSDate: Date;

  /** Identyfikatory logów wysyłki u dostawców do ewentualnego debugowania. */
  public emailId: string;
  public smsId: string;

  /** Wewnętrzna notatka dotycząca tego konkretnego linku do płatności. */
  public linkNotes: string;


  /** Data i czas pierwszego kliknięcia w link przez klienta.
   */
  public firstOpenDate: Date;

  /** Data i czas ostatniego otwarcia strony z płatnością. */
  public lastOpenDate: Date;

  /** Data i czas anulowania wymogu płatności / rezerwacji. */
  public cancelled: Date;

  /** Kto anulował procedurę opłacenia linku. */
  public cancelledBy: string;

}
